import React, { Component } from "react";
import classes from "./BudgetForm.module.css";
import { Formik } from "formik";
import { Button } from "reactstrap";
class BudgetForm extends Component {
  render() {
    return (
      <Formik
        initialValues={this.props.values}
        onSubmit={(values, { setSubmitting }) => {
          values.agency_id = this.props.agencyID;
          if (!values.agency_budget_id) {
            values.agency_budget_id = 0;
            this.props.addBudget(values);
          } else {
            this.props.updateBudget(values);
          }
        }}
      >
        {({
          values,
          handleChange,
              handleBlur,
          handleSubmit
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit} className={classes.BudgetForm}>
            <small className={"d-block"}>
              <span style={{ color: "red" }}>*</span> required
            </small>
            <label className="required">Year</label>
            <input
              required
              type="Number"
              className="form-control"
              name={"agency_budget_year"}
              value={values.agency_budget_year}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <label className="required">Name</label>
            <input
              required
              name={"agency_budget_name"}
              className="form-control"
              value={values.agency_budget_name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <label className="required">Value($Mil)</label>
            <input
              required
              type="Number"
              className="form-control"
              name={"agency_budget_value"}
              value={values.agency_budget_value}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <label className="required">Expenditure</label>
            <input
              required
              className="form-control"
              name={"expenditure_or_funding"}
              value={values.expenditure_or_funding}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <label className="required">Category</label>
            <input
              required
              className="form-control"
              name={"agency_budget_category"}
              value={values.agency_budget_category}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <label className="required">Description</label>
            <input
              required
              className="form-control"
              name={"agency_budget_description"}
              value={values.agency_budget_description}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <br />
            <Button color="primary" type="submit">
              Submit
            </Button>{" "}
            <Button color="secondary" onClick={this.props.toggleSmallModalHandler}>
              Cancel
            </Button>
          </form>
        )}
      </Formik>
    );
  }
}
export default BudgetForm;
